import { useEffect } from 'react';
import '../../css/OrderProductGallery.css';
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

export default function OrderProductsGallary({ products }) {
  
useEffect(() => {
  let count = 1;

  const intervalId = setInterval(() => {
    console.log(count);  // ONLY one should appear per second
    count = count !== 5 ? count + 1 : 0;
  }, 1000);

  return () => clearInterval(intervalId); // Cleanup to prevent multiple intervals
}, []);
  return (
    <div className='gallery-container'>
      {products.map((product, index) => {
        const offset1 = index * -80; // shift left by 9% for each image
        const offset2 = index * 0; // shift left by 9% for each image
        const rotate = (index/2) * 5; // rotate more for each image

        return (
          <img
            key={index}
            src={`${adminUrl}/uploads/products/${product.images[0].preview}`}
            alt=""
            style={{
            //   left: `${offset}%`,
              transform: `rotate(${rotate}deg) translateX(${offset1}%) translateY(${offset2}%)`, 
              zIndex: 0 
            }}
            className= {`gallery-img g${0}`}
          />
        );
      })}
    </div>
  );
}
